export default __webpack_public_path__ + "static/media/r7.a9abbd7f.jpg";